import {Restangular} from 'ngx-restangular';

export const getServiceForResource = (resourceId: string, http: Restangular) => {
  console.log('resourceId: ', resourceId);
  let resourceParts = resourceId
    .split('/');

  resourceParts = resourceParts.slice(2, resourceParts.length);
  return http.oneUrl(resourceParts.pop(), resourceId);
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/shared/resources.ts